<template>
	<div>
		<form @submit.prevent="() => {}" @keyup.enter="() => {}" data-vv-scope="form">
			<div class="row">
				<div class="col-12">
					<h4 class="font-weight-normal">
						{{ $t(`global.settings.map.title`) }}
					</h4>
					<hr class="mt-2" />
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<MaterialSelect
						:disabled="readonlyFormItem"
						class="city-form-group city-bg"
						id="input-crs"
						name="crs"
						label="name"
						:filterable="true"
						:options="availableCrs"
						:reduce="option => option.name"
						v-model.trim="form.crs.epsg"
						v-validate="{ required: true, regex: /^EPSG:\d+$/i }"
						:inputClasses="[{'is-invalid': fnHasError('crs') }]"
						:error=" fnFirstError('crs')" :helpText="help.crs">
						{{ $t(`global.settings.map.crs.name`) }}
					</MaterialSelect>
				</div>
				<div class="col-12">
					<div class="row">
						<div class="col">
							<h6 class="font-weight-normal">
								{{ $t(`global.settings.map.crs.available`) }}
							</h6>
							<hr class="mt-2" />
						</div>
					</div>
					<div class="mb-3">
						<section class="mb-3">
							<ul class="list-group">
								<li class="list-group-item py-1 px-3"
									:class="{'disabled': readonlyFormItem}"
									v-for="(item, index) of form.projections"
									:key="index"
									:id="index"
									>
									<div class="d-flex flex-row justify-content-between align-items-center">
										<span>{{ item.epsg }}</span>
										<span>{{ item.name }}</span>
										<button
											v-if="!readonlyFormItem"
											data-toggle="tooltip-city"
											:title="$t(`global.remove`)"
											class="btn btn-sm btn-delete min-w-auto m-0 px-2 py-1"
											type="button"
											@click.prevent="removeProjection(item)">
											<i class="far fa-trash-alt"></i>
										</button>
									</div>
								</li>
							</ul>
							<div class="form-group city-form-group mb-0">
								<input
									type="hidden"
									name="projections"
									v-model="form.projections"
									v-validate="'required'">
								<small
									:class="{'d-block': fnHasError('projections')}"
									class="invalid-feedback">
									{{ fnFirstError('projections') }}
								</small>
							</div>
						</section>
						<section v-if="!readonlyFormItem">
							<form class="w-100" data-vv-scope="new-projection" @submit.prevent="() => {}" @keyup.enter="() => {}" >
								<div class="input-group">
									<MaterialInput
										:readonly="readonlyFormItem"
										:disabled="readonlyFormItem"
										type="text"
										class="city-form-group city-bg col m-0 p-0"
										id="input-projection-name"
										name="projection-name"
										v-model.trim="newProjection.name"
										v-validate="'required'"
										:inputClasses="[{'is-invalid': fnHasError('projection-name', 'new-projection') }]"
										:error="fnFirstError('projection-name', 'new-projection')">
										{{ $t(`global.settings.map.projection.name`) }}
									</MaterialInput>
									<MaterialInput
										:readonly="readonlyFormItem"
										:disabled="readonlyFormItem"
										type="text"
										class="city-form-group city-bg col m-0 p-0"
										id="input-projection-epsg"
										name="projection-epsg"
										v-uppercase
										v-model.trim="newProjection.epsg"
										v-validate="{ required: true, regex: /^EPSG:\d+$/i }"
										:inputClasses="[{'is-invalid': fnHasError('projection-epsg', 'new-projection') }]"
										:error=" fnFirstError('projection-epsg', 'new-projection')">
										{{ $t(`global.settings.map.projection.epsg`) }}
									</MaterialInput>
									<button
										data-toggle="tooltip-city"
										title="Adicionar Sistema de Coordenadas"
										class="btn btn-sm btn-main min-w-auto m-0 border-left-radius-0"
										type="button"
										@click.prevent="addProjection">
										<i class="fas fa-plus"></i>
									</button>
								</div>
							</form>
						</section>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row">
						<div class="col">
							<h6 class="font-weight-normal">
								{{ $t(`global.settings.scales.title`) }}
							</h6>
							<hr class="mt-2" />
						</div>
					</div>
					<div class="mb-3">
						<section class="mb-3">
							<ul class="list-group">
								<li class="list-group-item py-1 px-3"
									:class="{'disabled': readonlyFormItem}"
									v-for="(item, index) in itemsScaleResolution"
									:key="index"
									:id="index"
									>
									<div class="d-flex flex-row justify-content-between align-items-center">
										<span>{{ item.scale }}</span>
										<span>{{ item.resolution }}</span>
										<button
											v-if="!readonlyFormItem"
											data-toggle="tooltip-city"
											title="Remover"
											class="btn btn-sm btn-delete min-w-auto m-0 px-2"
											type="button"
											@click.prevent="removeScale(item)">
											<i class="far fa-trash-alt"></i>
										</button>
									</div>
								</li>
							</ul>
							<div class="form-group city-form-group mb-0">
									<input
										type="hidden"
										name="scales"
										v-model="form.scales"
										v-validate="'required'">
									<small
										:class="{'d-block': fnHasError('scales')}"
										class="invalid-feedback">
										{{ fnFirstError('scales') }}
									</small>
							</div>
						</section>
						<section v-if="!readonlyFormItem">
							<form class="w-100" data-vv-scope="new-scale" @submit.prevent="() => {}" @keyup.enter="() => {}" >
								<div class="input-group">
									<MaterialInput
										:readonly="readonlyFormItem"
										:disabled="readonlyFormItem"
										type="text"
										class="city-form-group city-bg col m-0 p-0"
										id="input-scale-name"
										name="scale-name"
										v-model.trim="newScale"
										v-decimal
										v-validate="'required|decimal'"
										:inputClasses="[{'is-invalid': fnHasError('scale-name', 'new-scale') }]"
										:error="fnFirstError('scale-name', 'new-scale')">
										{{ $t(`global.settings.scales.name`) }}
									</MaterialInput>
									<button
										data-toggle="tooltip-city"
										:title="$t(`global.settings.scales.actions.add`)"
										class="btn btn-sm btn-main min-w-auto m-0 border-left-radius-0"
										type="button"
										@click.prevent="addScale">
										<i class="fas fa-plus"></i>
									</button>
								</div>
							</form>
						</section>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row">
						<div class="col">
							<h6 class="font-weight-normal">
								{{ $t(`global.settings.center.title`) }}
							</h6>
							<hr class="mt-2" />
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-4">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-center-lon"
								name="center-lon"
								v-model.trim="form.center.x"
								v-decimal v-validate="'required|decimal'"
								:inputClasses="[{'is-invalid': fnHasError('center-lon') }]"
								:error=" fnFirstError('center-lon')" >
								{{ $t(`global.settings.center.lon`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-sm-4">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-center-lat"
								name="center-lat"
								v-model.trim="form.center.y"
								v-decimal
								v-validate="'required|decimal'"
								:inputClasses="[{'is-invalid': fnHasError('center-lat') }]"
								:error=" fnFirstError('center-lat')" >
								{{ $t(`global.settings.center.lat`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-sm-4">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-scale"
								name="scale"
								v-model.trim="form.scale"
								v-decimal
								v-validate="'required|decimal'"
								:inputClasses="[{'is-invalid': fnHasError('scale') }]"
								:error=" fnFirstError('scale')">
								{{ $t(`global.settings.center.scale`) }}
							</MaterialInput>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row">
						<div class="col">
							<h6 class="font-weight-normal">
								{{ $t(`global.settings.extent.title`) }}
							</h6>
							<hr class="mt-2" />
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-3">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-extent-minx"
								name="extent-minx"
								v-model.trim="form.extent.minX"
								v-decimal
								v-validate="'required|decimal'"
								:inputClasses="[{'is-invalid': fnHasError('extent-minx') }]"
								:error=" fnFirstError('extent-minx')" >
								{{ $t(`global.settings.extent.minx`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-sm-3">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-extent-miny"
								name="extent-miny"
								v-model.trim="form.extent.minY"
								v-decimal
								v-validate="'required|decimal'"
								:inputClasses="[{'is-invalid': fnHasError('extent-miny') }]"
								:error=" fnFirstError('extent-miny')">
								{{ $t(`global.settings.extent.miny`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-sm-3">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-extent-maxx"
								name="extent-maxx"
								v-model.trim="form.extent.maxX"
								v-decimal
								v-validate="{required: true, decimal: true, min_value: form.extent.minX}"
								:inputClasses="[{'is-invalid': fnHasError('extent-maxx') }]"
								:error=" fnFirstError('extent-maxx')" >
								{{ $t(`global.settings.extent.maxx`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-sm-3">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-extent-maxx"
								name="extent-maxy"
								v-model.trim="form.extent.maxY"
								v-decimal
								v-validate="{required: true, decimal: true, min_value: form.extent.minY}"
								:inputClasses="[{'is-invalid': fnHasError('extent-maxy') }]"
								:error=" fnFirstError('extent-maxy')" >
								{{ $t(`global.settings.extent.maxy`) }}
							</MaterialInput>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-12">
							<div class="form-group city-form-group">
								<help-span :helpText="help.extent" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row">
						<div class="col">
							<h6 class="font-weight-normal">
								{{ $t(`global.settings.initial-extent.title`) }}
							</h6>
							<hr class="mt-2" />
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-3">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-initial-extent-minx"
								name="initial-extent-minx"
								v-model.trim="form.initial_extent.minX"
								v-decimal
								v-validate="'required|decimal'"
								:inputClasses="[{'is-invalid': fnHasError('initial-extent-minx') }]"
								:error=" fnFirstError('initial-extent-minx')" >
								{{ $t(`global.settings.initial-extent.minx`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-sm-3">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-initial-extent-miny"
								name="initial-extent-miny"
								v-model.trim="form.initial_extent.minY"
								v-decimal
								v-validate="'required|decimal'"
								:inputClasses="[{'is-invalid': fnHasError('initial-extent-miny') }]"
								:error=" fnFirstError('initial-extent-miny')" >
								{{ $t(`global.settings.initial-extent.miny`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-sm-3">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-initial-extent-maxx"
								name="initial-extent-maxx"
								v-model.trim="form.initial_extent.maxX"
								v-decimal
								v-validate="{required: true, decimal: true, min_value: form.initial_extent.minX}"
								:inputClasses="[{'is-invalid': fnHasError('initial-extent-maxx') }]"
								:error=" fnFirstError('initial-extent-maxx')" >
								{{ $t(`global.settings.initial-extent.maxx`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-sm-3">
							<MaterialInput
								:readonly="readonlyFormItem"
								:disabled="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								id="input-initial-extent-maxy"
								name="initial-extent-maxy"
								v-model.trim="form.initial_extent.maxY"
								v-decimal
								v-validate="{required: true, decimal: true, min_value: form.initial_extent.minY}"
								:inputClasses="[{'is-invalid': fnHasError('initial-extent-maxy') }]"
								:error=" fnFirstError('initial-extent-maxy')" >
								{{ $t(`global.settings.initial-extent.maxy`) }}
							</MaterialInput>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-12">
							<div class="form-group city-form-group">
								<help-span :helpText="help.initial_extent" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row">
						<div class="col">
							<h6 class="font-weight-normal">
								{{ $t(`global.settings.boundary.title`) }}
							</h6>
							<hr class="mt-2" />
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<div class="form-group city-form-group city-bg mb-0">
								<MaterialTextarea
									:readonly="readonlyFormItem"
									:disabled="readonlyFormItem"
									class="city-form-group city-bg"
									id="input-boundary"
									name="boundary"
									:rows="6"
									v-model.trim="form.boundary"
									:helpText="help.boundary"
									v-validate="'geometryFeature'"
									:inputClasses="[{'is-invalid': fnHasError('boundary') }]"
									:error="fnFirstError('boundary')">
									{{ $t(`global.settings.boundary.name`) }}
								</MaterialTextarea>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>

	import {SCALES_DEFAULT, getResolutionFromScale, getScaleFromResolution} from '@/components/maps/shared/catalog/utils/MapUtils';
	import GlobalMixin from '@/app/shared/mixins/global';
	import {isJson, isObject} from '@config/utils';
	import GeoJSON from 'ol/format/GeoJSON';

	let initialProjection = {name: null, epsg: null};

	export default {
		name: 'ManageMapProperties',
		mixins: [
			GlobalMixin
		],
		components: {
			HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
		},
		inject: ['parentValidator'],
		props: {
			moduleCode: {
				type: String,
				require: true,
			},
			readonlyFormItem: {
				type: Boolean,
				default: true
			},
			value: {
				type: Object,
				default: () => {
					return {
						scale: null,
						center: {
							x: null,
							y: null,
						},
						crs: {
							epsg: null,
						},
						projections: [],
						resolutions: [],
						scales: [],
						extent: {
							minX: -180,
							minY: -90,
							maxX: 180,
							maxY: 90,
						},
						initial_extent: {
							minX: -180,
							minY: -90,
							maxX: 180,
							maxY: 90,
						},
						boundary: null,
					}
				}
			},
		},
		data() {
			return {
				form: {
					center: {
						x: null,
						y: null,
					},
					crs: {
						epsg: null,
					},
					projections: [],
					resolutions: [],
					scales: [],
					extent: {
						minX: -180,
						minY: -90,
						maxX: 180,
						maxY: 90,
					},
					initial_extent: {
						minX: -180,
						minY: -90,
						maxX: 180,
						maxY: 90,
					},
					boundary: null,
				},
				newProjection: {
					name: null,
					epsg: null,
				},
				newScale: null,
			}
		},
		computed: {
			defaultProjections() {
				return [
					{
						name: 'WGS84',
						epsg: 'EPSG:4326',
					},
					{
						name: 'WGS 84 / Pseudo-Mercator',
						epsg: 'EPSG:3857',
					},
					{
						name: 'ETRS89 / Portugal TM06',
						epsg: 'EPSG:3763',
					},
				];
			},
			defaultScales() {
				return SCALES_DEFAULT ?? [];
			},
			// defaultResolutions() {
			// 	const defaultScales = this.defaultScales;
			// 	const srs = this.form.crs.epsg ?? (this.defaultProjections.length ? this.defaultProjections[0]?.epsg : 'EPSG:4326');
			// 	return defaultScales.reduce((acc, scale) => {
			// 		acc.push(getResolutionFromScale(srs, scale));
			// 		return acc;
			// 	}, []);
			// },
			itemsScaleResolution() {
				return this.form.scales
					.slice()
					.sort(function(a, b) {
						return b - a; // desc, a - b; // asc
					})
					.map((scale, idx) => {
						return {
							scale,
							resolution: this.resolutionFromScale(scale),
						}
					});
			},
			help() {
				return {
					crs: `global.settings.help.crs`,
					extent: `global.settings.help.extent`,
					initial_extent: `global.settings.help.initial-extent`,
					boundary: `global.settings.help.boundary`,
				}
			},
			availableCrs() {
				return this.form.projections.map(x => {return {name: x.epsg};});
			}
		},
		created () {
			this.$validator = this.parentValidator;
		},
		mounted() {
			this.initialize();
		},
		methods: {
			initialize() {
				if(this.form.projections.length == 0) {
					this.form.projections = this.defaultProjections;
					this.form.crs.epsg = this.form.projections.length ? this.form.projections[0].epsg : 'EPSG:4326';
				}

				if(this.form.scales.length == 0) {
					this.form.scales = this.defaultScales;
				}
			},
			copyValue (value) {
				// manter a compatibilidade para trás onde guarda apenas as resolutions
				if((value?.scales ?? []).length == 0 && (value?.resolutions ?? []).length > 0) {
					value.scales = this.setScalesFromResolutions(value.resolutions, value.crs.epsg, false);
				}
				Object.assign(this.form, value);
			},
			handleValue () {
				this.$emit('input', this.form);
			},
			transformGeojsonObjectToString(value) {
				return isObject(value) && isJson(value) ? JSON.stringify(value) : value;
			},
			makeValidBoundary(value) {
				try {
					value = this.transformGeojsonObjectToString(value);
					// se já for geometria não faz nada
					let geometry = (new GeoJSON()).readGeometry(value);
				} catch (e) {
					try {
						const features = (value ? (new GeoJSON()).readFeatures(value) : null) ?? [];
						const feature = features.length ? features[0] : features;
						if(feature) {
							value = this.transformGeojsonObjectToString((new GeoJSON()).writeGeometry(feature.getGeometry()));
						}
					} catch (e) {}
				}
				this.form.boundary = value;
			},
			addProjection(event) {
				this.$validator.validateAll('new-projection').then((result) => {
					if(!result){
						this.showError(this.$t(`global.msg.error.form`));
						return;
					}
					if(this.form.projections.find(x => x.epsg.trim().toUpperCase() == this.newProjection.epsg.trim().toUpperCase())){
						// this.showError(this.$t(`global.msg.error.projection-duplicate`));
						return;
					}

					this.$set(this.form.projections, this.form.projections.length, Object.assign({}, this.newProjection))
					Object.assign(this.newProjection, initialProjection);
					this.resetValidator();
					this.setValidationField('projections');
				});
				if (event){
					event.preventDefault();
					event.stopPropagation();
				}
			},
			removeProjection(item) {
				this.hideTooltip();
				let index = this.form.projections.findIndex(p => p.epsg == item.epsg);
				if(index != -1) {
					if(this.form.projections[index].epsg == this.form.crs.epsg){
						this.form.crs.epsg = null;
					}
					this.$delete(this.form.projections, index);
					this.setValidationField('projections');
				}
			},
			addScale() {
				this.$validator.validateAll('new-scale')
				.then((result) => {
					if(!result){
						this.showError(this.$t(`global.msg.error.form`));
						return;
					}
					if(this.form.scales.find(x => x == this.newScale)){
						// this.showError(this.$t(`${app}.msg.error.resolution-duplicate`));
						return;
					}

					this.form.scales.push(this.newScale);
					this.newScale = null;
					this.setValidationField('scales');
					this.resetValidator();
				});
			},
			removeScale(item) {
				this.hideTooltip();
				let index = this.form.scales.findIndex(p => p == item.scale);
				if(index != -1) {
					this.$delete(this.form.scales, index);
					this.setValidationField('scales');
				}
			},
			setResolutionsFromScales(scales, epsg, toApplyForm = true) {
				const resolutions = (scales ?? this.form.scales).map(scale => this.resolutionFromScale(scale, epsg))
				.sort(function(a, b) {
					return b - a; // desc, a - b; // asc
				});

				if(toApplyForm) {
					this.form.resolutions = resolutions;
				}
				return resolutions;
			},
			setScalesFromResolutions(resolutions, epsg, toApplyForm = true) {
				const scales = (resolutions ?? this.form.resolutions).map(resolution => this.scaleFromResolution(resolution, epsg));
				if(toApplyForm) {
					this.form.scales = scales;
				}
				return scales;
			},
			setValidationField(name) {
				const field = this.$validator.fields.find({ name });
				if(field){
					field.setFlags({ dirty: true, valid: this.form[name].length>0 });
				}
			},
			scaleFromResolution(resolution, epsg) {
				return getScaleFromResolution(epsg ?? this.form.crs.epsg, resolution);
			},
			resolutionFromScale(scale, epsg) {
				return getResolutionFromScale(epsg ?? this.form.crs.epsg, scale);
			},
		},
		watch: {
			value: {
				deep: true,
				immediate: true,
				handler(newValue) {
					this.copyValue(newValue)
				}
			},
			form: {
				deep: true,
				immediate: false,
				handler(newValue) {
					this.handleValue();
				}
			},
			"form.boundary": {
				deep: true,
				immediate: true,
				handler(newValue) {
					this.makeValidBoundary(newValue);
				}
			},
			"form.crs.epsg": {
				deep: true,
				immediate: true,
				handler(newValue) {
					this.setResolutionsFromScales();
				}
			},
			"form.scales": {
				deep: true,
				immediate: true,
				handler(newValue) {
					this.setResolutionsFromScales();
				}
			}
		},
	}
</script>